import React from 'react';
import { RouteObject } from 'react-router-dom';

import DashboardContainer from '../../containers/dashboard/Dashboard.container';

import DashboardCrumb from '../../crumbs/dashboard/Dashboard.crumb';

import ProtectedRoute from '../ProtectedRoute';

const dashboardRoutes: RouteObject[] = [
  {
    // Pre-v3 dashboard, preserved at /dashboard-legacy after the v3 cutover.
    // Still renders inside the legacy AuthenticatedLayout, so its sidebar
    // remains the full-navigation gateway to surfaces not yet in v3 (HR,
    // funds, events, contacts, precedents, admin).  v3 now owns /dashboard.
    path: 'dashboard-legacy',
    element: (
      <ProtectedRoute>
        <DashboardContainer />
      </ProtectedRoute>
    ),
    handle: {
      crumb: () => <DashboardCrumb />
    }
  }
];

export default dashboardRoutes;
